import Provider         from "../../common/model/Provider";
import Config           from "../../common/model/Config";
import GlobalVar        from "../../common/model/GlobalVar";
import UmdOption        from "../../common/model/UmdOption";

import logo_pass        from "../../common/resource/img/logo_pass.png";
import logo_payco       from "../../common/resource/img/logo_payco.png";
import logo_kakao       from "../../common/resource/img/logo_kakao.png";
import logo_kakaopay    from "../../common/resource/img/logo_kakaopay.png";
import logo_kb          from "../../common/resource/img/logo_kb.png";
import logo_samsung     from "../../common/resource/img/logo_samsung.png";
import logo_naver       from "../../common/resource/img/logo_naver.png";
import logo_toss        from "../../common/resource/img/logo_toss.png";
import logo_shinhan     from "../../common/resource/img/logo_shinhan.png";
import logo_banksalad   from "../../common/resource/img/logo_banksalad.png";
import logo_hana        from "../../common/resource/img/logo_hana.png";
import logo_sample      from "../../common/resource/img/logo_sample.png";
import { webAccess }    from "../../common/controller/webAccessibilityCtrl";
import { common }       from "../../common/controller/validationCtrl";
import { regex }        from "../../common/utils/regex";
import { providerChk }  from "../../common/utils/provider.id.check";
import { mobile }       from "./mobileCtrl";
import { vaild }        from "./validationCtrl";
import { template }     from "./templateCtrl";
import { viewAsyn }     from "./viewAsynProcessing";
import { device } from "../../common/utils/deviceCheck";

var rootId = "";
var pcMobileId = "";
export const viewEvent = {
  init: () => {
    rootId = Config.appendElementTagId;
    pcMobileId = GlobalVar.pcMobileId;

    viewEvent.reqeustFormEvents();
    vaild.inputSizeCheck();

    /*$("#oacxEmbededContents header h1").on('click',()=>{
			const md = new MobileDetect(window.navigator.userAgent);
			// PC: md.mobile() =  null,   md.tablet() = null
			// MO: md.mobile() =  iPhone, md.tablet() = null
			// TB: md.mobile() =  iPad,   md.tablet() = iPad
		alert(`${window.navigator.userAgent} 
        ✔mobile: ${md.mobile()} 
        ✔phone:  ${md.phone()}
        ✔tablet: ${md.tablet()}
        ✔userAgent: ${md.userAgent()}
        ✔os: ${md.os()}`)
		}) */

  },
  view_msg: (title, code, message, confirmEvent) => {
    var json = {
      title: title !== undefined ? title : "",
      message: message !== undefined ? message : "",
    };
    template.popup_valid_warring(json);
    // $(`${rootId} #view_err .tit`).text(title !== undefined ? title : "");
    // $(`${rootId} #view_err .errerContent`).html(message !== undefined ? message : "");
    $(`${rootId} #view_err`).addClass("view");
    webAccess.targetFocus(`${rootId} #view_err .alert .a11y-hidden`);
    window.scrollTo(0, 0);

    // Confirm/close Button
    $(`${rootId} #view_err button`).off("click").on("click", () => {
        $("#view_err").removeClass("view");
        mobile.show_agree_button();
        if (confirmEvent !== undefined) {
          confirmEvent();
        }
    });
  },
  view_wait_provider: () => {
    const providerId = Provider.providerId;
    viewEvent.showStep2();
    $(`${rootId} .csTxt`).removeClass("view");
    function render(title, logo) {
      $(`${rootId} .m_icon .logoBox img`).attr("src", logo);
      $(`${rootId} .m_icon .logoBox img`).attr("alt", title);
      $(`${rootId} #provider_icon_url`).attr("src", logo);
      $(`${rootId} #provider_icon_url`).attr("alt", title);
      $(`${rootId} .serviceName`).text(title);
    }
    if (providerChk.isPass(providerId)) {
      render("통신사", logo_pass);
      $(`${rootId} #div_pass`).addClass("view");
    } else if (providerChk.isKb(providerId)) {
      render("KB모바일", logo_kb);
      $(`${rootId} #div_kb`).addClass("view");
    } else if (providerChk.isSamsung(providerId)) {
      render("삼성패스", logo_samsung);
      $(`${rootId} #div_kica`).addClass("view");
    } else if (providerChk.isKakao(providerId)) {
      render("카카오톡", logo_kakao);
      $(`${rootId} #div_kakao`).addClass("view");
    } else if (providerChk.isKakaoPay(providerId)) {
      render("카카오페이", logo_kakaopay);
      $(`${rootId} #div_kakaopay`).addClass("view");
    } else if (providerChk.isPayco(providerId)) {
      render("페이코", logo_payco);
      $(`${rootId} #div_payco`).addClass("view");
    } else if (providerChk.isNaver(providerId)) {
      render("네이버", logo_naver);
      $(`${rootId} #div_naver`).addClass("view");
    } else if (providerChk.isToss(providerId)) {
      render("토스", logo_toss);
      $(`${rootId} #div_toss`).addClass("view");
    } else if (providerChk.isShinhan(providerId)) {
      render("신한인증서", logo_shinhan);
      $(`${rootId} #div_shinhan`).addClass("view");
    } else if (providerChk.isBanksalad(providerId)) {
      render("뱅크샐러드", logo_banksalad);
      $(`${rootId} #div_banksalad`).addClass("view");
    } else if (providerChk.isHana(providerId)) {
      render("하나인증서", logo_hana);
      $(`${rootId} #div_hana`).addClass("view");
    } else {
      render(providerId, logo_sample);
    }
  },
  serviceSelect: () => {
    //서비스 선택
    $(`${rootId} ${pcMobileId} .oacx_providerList li`).on("click", (e) => {
      // webAccess.targetFocus(`${rootId} ${pcMobileId} [data-id='oacx_name']`)

      Provider.providerId = $(e.currentTarget).find("input[name=provider]").val();
      $(e.currentTarget).find("input[name=provider]").prop("checked", true);

      if ( Provider.compareCI == false && providerChk.isSamsung(Provider.providerId)) {
        viewEvent.hideBirthSsn();
      } else {
        viewEvent.showBirthSsn();
      }
      
      // 통신사 패스 선택에 따라 UI 화면 변경
      if (providerChk.isPass(Provider.providerId)) {
        $(`${rootId} ${pcMobileId} .telecom`).show();
        $(`${rootId} ${pcMobileId} .none-telecom`).hide();
      }else {
        $(`${rootId} .telecom`).hide();
        $(`${rootId} .none-telecom`).show();
      }

    });
  },
  successEventHandler: (callback) => {
    //인증완료
    $(`${rootId} #step2Success`).on("click", () => {
      viewAsyn.finishAuth(callback);
    });
  },
  reqeustFormEvents: () => {
    //개인정보이용동의(필수)
    $(`${rootId} #policy1_btn`).on("click", () => {
      $(`${rootId} ${pcMobileId} #view_policy1`).addClass("view");
      webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy1 .policy .cont`);
    });
    //서비스이용약관동의(필수)
    $(`${rootId} #policy2_btn`).on("click", () => {
      $(`${rootId} ${pcMobileId} #view_policy2`).addClass("view");
      webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy2 .policy .cont`);
    });
    //제3자 정보제공동의(필수)
    $(`${rootId} #policy3_btn`).on("click", () => {
      $(`${rootId} ${pcMobileId} #view_policy3`).addClass("view");
      webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy3 .policy .cont`);
    });
    //고유식별정보처리동의(필수)
    $(`${rootId} #policy4_btn`).on("click", () => {
      $(`${rootId} ${pcMobileId} #view_policy4`).addClass("view");
      webAccess.targetFocus(`${rootId} ${pcMobileId} #view_policy4 .policy .cont`);
    });

    //다른서비스는 없나요
    /* $(`${rootId} .otherSrv`).on('click',()=>{
        $(`${rootId} #view_otherSrv`).addClass("view");
        webAccess.targetFocus(`${rootId} #view_otherSrv .alert.other`);
    }) */

    //통신사 선택
    $(`${rootId} [data-id='oacx_phone0']`).on("change", (e) => {
      if (!$(e.currentTarget).is("option:not([disabled=disabled])")) {
        $(e.currentTarget).css("color", "#4d4d4d");
        $(e.currentTarget).css("color", "#4d4d4d");
      } else {
        $(e.currentTarget).css("color", "rgba(55, 59, 64, 0.3)");
      }
    });

    if (Config.id == "sign") {
      $(`${rootId} .signView`).show();
      //서명 전문보기
      $(`${rootId} #signOrigin`).on("click", () => {
        $(`${rootId} #view_sign_origin .cont `).html(
          Provider.contentInfo.signTarget
        );
        $(`${rootId} #view_sign_origin`).addClass("view");
        $(`${rootId} #view_sign_origin`).css("font-size", "13px");
      });
    }

    //popup 닫기
    $(`${rootId} .btnArea button, ${rootId} button.close`).on("click", (e) => {
      $(`${rootId} .alertArea`).removeClass("view");
    });

    //서비스 시용에 대한 전체동의 이벤트
    $(`${rootId} #oacx_total`).on("click", (e) => {
      if ($(e.currentTarget).val() == "N") {
        $(`${rootId} .pcAgree input[type=checkbox]`).prop("checked", true);
        $(e.currentTarget).val("Y");
      } else {
        $(`${rootId} .pcAgree input[type=checkbox]`).prop("checked", false);
        $(e.currentTarget).val("N");
      }
    });
    //개별 동의 체크 항목
    $(`${rootId} #oacx_policy1, ${rootId} #oacx_policy2, ${rootId} #oacx_policy3, ${rootId} #oacx_policy4`).on("click", (e) => {
      var isAllChk = false;
      var chkBxArr = $(`${rootId} .pcAgree input[type=checkbox]`);
      chkBxArr.each(function (i, elem) {
        if ($(elem).prop("checked")) {
          isAllChk = true;
        } else {
          isAllChk = false;
          return false;
        }
      });
      if (isAllChk) {
        $(`${rootId} #oacx_total`).prop("checked", true);
        $(`${rootId} #oacx_total`).val("Y");
      } else {
        $(`${rootId} #oacx_total`).prop("checked", false);
        $(`${rootId} #oacx_total`).val("N");
      }
    });

    //사용안내
    $(`${rootId} .guide .linkArea`).on("click", () => {
      const path = Config.file.guide.path;
      window.open( path, "간편인증 사용방법 안내", "location=no, directories=no,resizable=no,status=no,toolbar=no,menubar=no, width=1200,height=720, right=0, top=0" );
    });


    // 인증요청 바깥 이벤트
    UmdOption.trigger.request = ()=>{
        if(viewEvent.formValidationCheck()){
            //인증요청
            viewAsyn.requestAuth();
        }
    }

    //인증요청
    $(`${rootId} #step1Request`).on("click", () => {
      viewEvent.formValidation_popup();
    });

    //취소
    $(`${rootId} .popup-close`).on("click", (e) => {
      viewEvent.closePopup();

      UmdOption.callback.event.close();
      if (GlobalVar.closeEvt !== undefined) {
        const closeEvt = GlobalVar.closeEvt;
        closeEvt(e);
      }
    });
  },
  formValidationCheck: () => {
    const name = common.trim( $(`${rootId} ${pcMobileId} [data-id='oacx_name']`).val() );
    const num1 = common.trim( $(`${rootId} ${pcMobileId} [data-id='oacx_num1']`).val() );
    const num2 = common.trim( $(`${rootId} ${pcMobileId} [data-id='oacx_num2']`).val() );
    const birth = common.trim(  $(`${rootId} ${pcMobileId} [data-id='oacx_birth']`).val() );
    var providerId = "";
    if (device.isMobileUI()) {
      providerId = $(`${rootId} ${pcMobileId} .oacx_providerList li.selected input[name=provider]`).val();
    } else {
      providerId = $(`${rootId} ${pcMobileId} .oacx_providerList li input[name=provider]:checked`).val();
    }
    var phone = "";
    var telcoTycd = null;

    // alert(`
    // ✔ Device Code: ${Provider.deviceInfo.code}
    // ✔ UI Class: ${pcMobileId}
    // ✔ Select Provider Id: ${providerId}
    // `)
    if (providerId === undefined || providerId == "") {
      $(`${rootId} input`).blur();
      viewEvent.view_msg("안내", "", "인증서비스를 선택하여 주십시오.", () => {
        $(`${rootId} input`).blur();
        $(`${rootId} ${pcMobileId} .oacx_providerList li:first-child input[name=provider]`).focus();
        // $(".main section").scrollTop(0,0);
      });
      return false;
    }

    if (!vaild.nameCheck(name)) {
      return false;
    }

    if (Provider.isBirth) {
      if (!vaild.birthCheck(birth)) {
        return false;
      }
    } else {
      if (!vaild.ssCheck(num1, num2)) {
        return false;
      }
    }

    if (providerChk.isPass(providerId)) {
      phone = common.trim( $(`${rootId} ${pcMobileId} [data-id='oacx_phone3']`).val());
      var selected = $(`${rootId} ${pcMobileId} [data-id='oacx_phone0'] option:not([disabled=disabled]):selected`).val();
      telcoTycd = selected === undefined ? null : selected;

      if (!vaild.telcoTycdCheck()) {
        return false;
      }
    } else {
      phone = common.trim($(`${rootId} ${pcMobileId} [data-id='oacx_phone2']`).val());
    }

    if (!vaild.phoneCheck(phone, providerId)) {
      return false;
    }

    //PC, Tablet 환경에서만 작동
    if (!device.isMobileUI()) {
      if (!vaild.checkBoxVaild()) {
        return false;
      }
    }

    //개인정보 이용 동의 확인 여부
    Provider.userInfo.privacy = $(`${rootId} #m_policy1_btn`).length != 0 ? 1 : 0;
    //서비스 이용약관 동의 확인 여부
    Provider.userInfo.policy3 = $(`${rootId} #m_policy2_btn`).length != 0 ? 1 : 0;
    //제3자 정보제공약관 확인 여부
    Provider.userInfo.policy4 = $(`${rootId} #m_policy3_btn`).length != 0 ? 1 : 0;
    //고유식별정보처리 동의 확인 여부
    Provider.userInfo.terms = $(`${rootId} #m_policy4_btn`).length != 0 ? 1 : 0;

    var phoneNm = "";
    if (providerChk.isPass(providerId)) {
      phoneNm = common.trim( $(`${rootId} ${pcMobileId} .telecom [data-id='oacx_phone1']`).val() );
    } else {
      phoneNm = common.trim(
        $(`${rootId} ${pcMobileId} .none-telecom [data-id='oacx_phone1']`).val()
      );
    }
    Provider.userInfo.name = name;
    Provider.userInfo.ssn1 = num1;
    Provider.userInfo.ssn2 = num2;
    Provider.userInfo.phone = phoneNm + phone;
    Provider.userInfo.birthday = Provider.isBirth? birth : regex.convertBirthDay(num1, num2);
    Provider.userInfo.telcoTycd = telcoTycd;
    Provider.providerId = providerId;
    Provider.provider = providerId + Config.provider.separator + Config.provider.version;
    return true;
  },
  formValidation_popup: () => {
    if (!viewEvent.formValidationCheck()) {
      return false;
    }
    if (device.isMobileUI()) {
      //개인정보 동의
      mobile.nextView();
    } else {
      //PC, Tablet 환경에서만 작동
      if(UmdOption.callback.event.request() === false){ 
          return false; 
      }
      //인증요청
      viewAsyn.requestAuth();
    }
  },
  closePopup: () => {
    $(`${rootId}`).html("");
    viewEvent.hideBackScreen();

    $(window).off('resize')
    $(window).off("orientationchange")
  },
  hidePopup: () => {
    $(`${rootId} div.view`).removeClass("view");
  },
  showBackScreen: () => {
    $(`${rootId}`).append('<div id="bgScrn"></div>');
    $(`${rootId}`).show();
  },
  hideBackScreen: () => {
    $(`${rootId} #bgScrn`).remove();
  },
  showStep1: () => {
    $(`${rootId} #oacxEmbededContents`).show();
    $(`${rootId} .standby`).hide();
    $(`${rootId} .csTxt`).removeClass("view");
  },
  showStep2: () => {
    $(`${rootId} .pcView, ${rootId} .mobileView`).hide();
    $(`${rootId} .standby`).show();
    /* if(!$(`${rootId} .csTxt`).is(".view")){
            $(`${rootId} .csTxt`).addClass("view");
        } */
    webAccess.targetFocus(".standby");
  },
  showStepBtn: () => {
    $(`${rootId} #step1Request`).removeAttr("disabled");
    $(`${rootId} #step1Request`).removeClass("disabled");
    $(`${rootId} #step2Success`).removeAttr("disabled");
    $(`${rootId} #step2Success`).removeClass("disabled");
  },
  hideStepBtn: () => {
    $(`${rootId} #step1Request`).attr("disabled", "disabled");
    $(`${rootId} #step1Request`).addClass("disabled");
    $(`${rootId} #step2Success`).attr("disabled", "disabled");
    $(`${rootId} #step2Success`).addClass("disabled");
  },
  showBirthSsn: () => {
    $(`${rootId} .oacx-birth`).show();
    $(`${rootId} .oacx-ssn`).show();
  },
  hideBirthSsn: () => {
    $(`${rootId} .oacx-birth`).hide();
    $(`${rootId} .oacx-ssn`).hide();
  }
};
